export default {
      id: "drop-usage",
      viewBox: "0 0 424 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#drop",
      toString: function () {
        return this.url;
      }
    }